// extracted by mini-css-extract-plugin
module.exports = {"addAccountForm":"_2y6U2G_n","addAccountTitle":"_1Jskt_9q","buttonHolder":"_2SRApST0","adminBox_tkLoader_position":"_2x2NPAMz"};